import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { Camera } from './contexts/CameraContext'

import { applyDynamicViewHeight } from './services/windowResizeSvc'
import { Auth } from './contexts/AuthContext';
import { BrowserRouter } from 'react-router-dom'

const { pathname } = window.location;
const versionRegex = /^\/v\d+\.\d+\.\d+/;
const match = pathname.match(versionRegex);
const basename = match ? match[0] : '';

ReactDOM.render(
  <React.StrictMode>
    <Camera>
      <Auth>
        <BrowserRouter basename={basename}>
          <App />
        </BrowserRouter>
      </Auth>
    </Camera>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


// Call the element loader after the app has been rendered the first time
defineCustomElements(window);

applyDynamicViewHeight()